import { render } from "./Cooperative.vue?vue&type=template&id=5b1b5d76&scoped=true"
import script from "./Cooperative.vue?vue&type=script&lang=js"
export * from "./Cooperative.vue?vue&type=script&lang=js"

import "./Cooperative.vue?vue&type=style&index=0&id=5b1b5d76&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1b5d76"]])

export default __exports__